import { createSlice } from "@reduxjs/toolkit";

export const sliceAuthUser = createSlice({
  name: "authUser",
  initialState: {
    data: {},
    permission: {},
    alloted_numbers: {},
  },
  reducers: {
    fetcheddata: (state, { payload }) => {
      state.data = payload.data;
    },

    logout: (state) => {
      state.data = sliceAuthUser.getInitialState().data;
    },
    setpermission: (state, { payload }) => {
      state.permission = payload.data;
    },
    setallotednumber: (state, { payload }) => {
      state.alloted_numbers = payload.data;
    },
  },
});

export const { fetcheddata, logout, setpermission, setallotednumber } =
  sliceAuthUser.actions;

export const SetUserData = (data) => async (dispatch) => {
  dispatch(fetcheddata({ data }));
};

export const SetUserpermission = (data) => async (dispatch) => {
  dispatch(setpermission({ data }));
};
export const SetAllotedNumber = (data) => async (dispatch) => {
  dispatch(setallotednumber({ data }));
};

export const LogoutUser = () => (dispatch) => {
  dispatch(logout({}));
};

export default sliceAuthUser.reducer;
